import * as api from '../api';
import * as types from './types';

export const setPlayerLoaded = (isLoaded) => {
  return {
    type: types.SET_PLAYER_LOADED,
    isLoaded
  }
}

export const setPlayerLoading = (isLoading) => {
  return {
    type: types.SET_PLAYER_LOADING,
    isLoading
  }
}

export const setPlayerLoadingError = () => {
  return {
    type: types.SET_PLAYER_LOADING_ERROR
  }
}

export const setPlayerNotFound = () => {
  return {
    type: types.SET_PLAYER_NOT_FOUND
  }
}

export const setLoggedIn = (isLoggedIn) => {
  return {
    type: types.SET_LOGGED_IN,
    isLoggedIn
  }
}

export const receivePlayerData = (playerData) => {
  return {
    type: types.RECEIVE_PLAYER,
    playerData
  };
}

export const receivePlayerLocation = (playerLocation) => {
  return {
    type: types.RECEIVE_PLAYER_LOCATION,
    playerLocation
  }
}

export const switchPlayerLocation = (location) => {
  return {
    type: types.SWITCH_PLAYER_LOCATION,
    location
  }
}

export const openAssessment = () => {
  return {
    type: types.OPEN_ASSESSMENT
  }
}

export const closeAssessment = () => {
  return {
    type: types.CLOSE_ASSESSMENT
  }
}

export const fetchPlayer = (shard) => {
  return async (dispatch, getState) => {
    const player = getState().player;

    if(!player.isLoaded && !player.isLoading && !player.isError) {
      dispatch(setPlayerLoading(true));

      let data;
      try {
        data = await api.fetchPlayer(shard);
      } catch(e) {
        if(!e.response || e.response.status === 404) {
          dispatch(setPlayerNotFound());
        }
        dispatch(setPlayerLoadingError());
        return;
      }

      dispatch(receivePlayerData({
          data: data,
          isLoaded: true,
          loggedIn: true
        }));
    }
  }
}

export const fetchAnonymous = (shard) => {
  return async (dispatch, getState) => {
    const player = getState().player;

    if(!player.isLoaded && !player.isLoading && !player.isError) {
      dispatch(setPlayerLoading(true));

      let data;
      try {
        data = await api.fetchAnonymous(shard);
      } catch(e) {
        dispatch(setPlayerLoadingError());
        return;
      }

      dispatch(receivePlayerData({
          data: data,
          isLoaded: true,
          loggedIn: false
        }));
    }
  }
};

export const fetchPlayerLocation = (shard) => {
  return async (dispatch, getState) => {
    const player = getState().player;

    if (player.isLoaded && !player.isError && !player.location.data_loaded) {
      let data;
      try {
        data = await api.fetchLocation(player.location.location.id, shard)
      } catch(e) {
        return;
      }

      dispatch(receivePlayerLocation(data))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/player.js